import Vue from 'vue'

const isServer = Vue.prototype.$isServer
export const on = (function () {
	if (!isServer && document.addEventListener) {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.addEventListener(event, handler, false)
			}
		}
	} else {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.attachEvent('on' + event, handler)
			}
		}
	}
})()

export function hasClass (el, className) {
	let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
	return reg.test(el.className)
}

export function addClass (el, className) {
	if (hasClass(el, className)) {
		return
	}

	let newClass = el.className.split(' ')
	newClass.push(className)
	el.className = newClass.join(' ')
}

export function removeClass (el, className) {
	if (!hasClass(el, className)) {
		return
	}
	let oldClass = el.className.split(' ')
	let newClass = oldClass.filter(v => v !== className)
	el.className = newClass.join(' ')
}
